import { OMNICHANNEL_REQUEST_SERVICE_APPLET_ID } from '../../../constants/omnichannelModals';
import { ServiceOrderDetails } from '../../../types/service-order';

export interface EditPurchaseOrderInfoModalProps {
  serviceOrderDetails: ServiceOrderDetails;
}

export default function ServiceRequestModal({
  serviceOrderDetails,
}: EditPurchaseOrderInfoModalProps) {
  const requestServiceOmnichannelModalId = `${OMNICHANNEL_REQUEST_SERVICE_APPLET_ID}-modal`;
  try {
    const existingEl = document.getElementById(requestServiceOmnichannelModalId);
    if (existingEl) {
      existingEl.remove();
    }

    const el = document.createElement('div');
    el.setAttribute('id', requestServiceOmnichannelModalId);
    el.setAttribute('rendersignin', 'false');
    el.setAttribute('location-id', serviceOrderDetails.locationId);
    el.setAttribute('asset-id', serviceOrderDetails.assetId);
    el.setAttribute('assettype', serviceOrderDetails.assetType);
    el.setAttribute('assetlocation', serviceOrderDetails.assetAddress);
    el.setAttribute('fullname', serviceOrderDetails.fullName);
    el.setAttribute('servicelocation', serviceOrderDetails.serviceLocation);
    el.setAttribute('serviceissue', serviceOrderDetails.serviceDescription);
    el.setAttribute('companyname', serviceOrderDetails.companyName);
    el.setAttribute('phonenumber', String(serviceOrderDetails.phone));
    el.setAttribute('emailaddress', serviceOrderDetails.email);
    document.body.appendChild(el);
  } catch (error) {
    console.log(error);
  }

  return <></>;
}
